import { IIconProps } from "./types"

export default function IconVec11(props: IIconProps) {
  const width = props.size || props.width || 91
  const height = props.size || props.height || 29
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 91 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4737 0H34.9474C34.9474 15.7526 27.1289 28.5248 17.4737 28.5248C7.82906 28.5248 0 15.7526 0 0H17.4737Z"
        fill="#CCCCCC"
      />
      <path
        d="M21.5868 9.61435C19.0576 7.14808 14.9856 7.23204 12.4879 9.80325C9.99014 12.364 10.0111 16.4464 12.5404 18.9127C15.0696 21.3685 19.152 21.2845 21.6498 18.7238"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M21.1579 18.4608L20.0664 17.2959L24.3273 16.4668L23.1938 20.6542L22.1129 19.4893L21.1579 18.4608Z"
        fill="black"
        stroke="#333333"
        strokeWidth="2.04129"
        strokeMiterlimit="2.61313"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.5245 0H56.0508C56.0508 15.7526 63.8694 28.5248 73.5245 28.5248C83.1796 28.5248 90.9982 15.7526 90.9982 0H73.5245Z"
        fill="#CCCCCC"
      />
      <path
        d="M69.4106 9.61435C71.9399 7.14808 76.0223 7.23204 78.52 9.80325C81.0178 12.364 80.9863 16.4464 78.4571 18.9127C75.9278 21.3685 71.8454 21.2845 69.3477 18.7238"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M69.853 18.4608L70.934 17.2959L66.6836 16.4668L67.8065 20.6542L68.8875 19.4893L69.853 18.4608Z"
        fill="black"
        stroke="#333333"
        strokeWidth="2.04129"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
